import React, { useState, useEffect } from 'react';
import api from "../../../services/api";

import Form from "./Form"

// core components
import SimpleHeader from '../../../components/Headers/SimpleHeader'

export default ({ ...props }) => {

    return (
        <>
            <SimpleHeader
                name="Nova Persona"
                parentName="Personas"
                {...props} />
            <Form
                {...props}
            />
        </>
    )


}
